import { graphql } from "react-relay";
import { FeedScheduler } from "@components/feed-scheduler";
import { ChromeDayPicker } from "./chrome-day-picker";

export const fragments = {
  viewer: graphql`
    fragment ChromeDay_viewer on Viewer
    @argumentDefinitions(
      calendarIds: { type: "[String!]!" }
      dates: { type: "[LocalDate!]!" }
      weekStartDates: { type: "[LocalDate!]!" }
      timeZone: { type: "String!" }
    ) {
      user {
        givenName
        emails
        id
        orgs(first: 1000000) {
          edges {
            node {
              id
              ...ChromeDayPicker_org
              ...FeedScheduler_org
              experiments
              primaryOrgEmail
              eventColoringSettingsErrorable {
                __typename

                ... on EventColoringSettings {
                  eventCategoryColorings {
                    active
                    eventCategory
                    googleColorKey
                    isUserSet
                  }
                }
              }
              userWorkingHours(resolveOverrides: false) {
                workingHours {
                  id
                  type
                  timeZone
                  daySettings {
                    day
                    setting {
                      minSlot
                      maxSlot
                      excludedSlots
                    }
                  }
                  dayOverrides {
                    date
                    setting {
                      minSlot
                      maxSlot
                      excludedSlots
                    }
                  }
                }
              }
              calendarTimeStatsList(calendarIds: $calendarIds, timeZone: $timeZone, dates: $dates) {
                __typename
                ... on CalendarTimeStatsList {
                  list {
                    calendarId
                    scoresByDate {
                      secondaryKey
                      busyMinutes
                      focusMinutes
                      totalMinutes
                      crawledStatus
                    }
                  }
                }
              }
              eventParentBaseWrapperByWeeksObject(
                weekStartDates: $weekStartDates
                calendarIds: $calendarIds
                includeAllDay: true
                timeZone: $timeZone
              ) {
                __typename
                ... on EventParentBaseWrapperByWeekObjectList {
                  list {
                    eventParentBases {
                      id
                      timestamp
                    }
                    eventParentsByDay {
                      eventParents {
                        id
                        eventParentBaseId
                        eventParentBaseTimestamp

                        events {
                          title
                          locked
                          isClockwiseEvent
                          isAllDay
                          calendarIds
                          organizer {
                            urnValue
                            responseStatus
                          }
                          attendees {
                            urnValue
                            responseStatus
                          }
                          creator {
                            urnValue
                          }
                          annotatedEvent {
                            userTags {
                              tag
                              states {
                                subjectType
                                subjectValue
                                value
                              }
                            }
                            orgTags {
                              tag
                              state {
                                subjectType
                                subjectValue
                                value
                              }
                            }
                          }
                          eventKey {
                            externalEventId
                          }
                          location
                          startTime {
                            dateOrDateTime
                            millis
                          }
                          endTime {
                            dateOrDateTime
                            millis
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};
